var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleIconsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:facebook",
    clipPath: "url(#clip0_485_2298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12.7397C24 6.11275 18.627 0.739746 12 0.739746C5.373 0.739746 0 6.11275 0 12.7397C0 18.7297 4.388 23.6937 10.125 24.5937V16.2087H7.078V12.7387H10.125V10.0967C10.125 7.08975 11.917 5.42775 14.658 5.42775C15.97 5.42775 17.344 5.66275 17.344 5.66275V8.61575H15.83C14.339 8.61575 13.874 9.54075 13.874 10.4897V12.7397H17.202L16.67 16.2097H13.874V24.5947C19.612 23.6937 24 18.7287 24 12.7397Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_2298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsFacebook);
export default __webpack_public_path__ + "static/media/simple-icons_facebook.745942a0dbafd89e800106014cdb1200.svg";
export { ForwardRef as ReactComponent };